<template>
  <div class="gd_hao10">
    <v-p-top @showResult="onShowResult"
             :phase="phase"
             :next_phase="next_phase"
             :records="records"
             :name="head.title"
             :remain_time="remain_time"
             :block_time="block_time"
             @end="handle_end"
             @change="changeFp"
    >
      <ul v-if="head.title === '重庆幸运农场'" slot="recodeNumber" class="num_record">
        <li v-for="(num, index) in records" :key="'re' + index" class="number2 item itemnc"
            :class="'numbernc' + num"></li>
      </ul>
      <ul v-else slot="recodeNumber" class="num_record">
        <li v-for="(num, index) in records" :key="'re' + index" class="number3 item item2"
            :class="'number3' + num"></li>
      </ul>
    </v-p-top>

    <template v-if="!$route.query.notice">
      <v-tab type="mini" v-if="tabs.length" class="page-tabs" @onChangeTab="onTabChanged" :current="tabs[curTab].value"
             :tabs="tabs"
             :border="true"/>

      <div class="gd_hao10-main page-wrapper" :style="contentStyleObj">

        <c-input class="c-input" v-model="chip" @again="handle_again" @certain="certain_handle"
                 @reset="reset_selected" />

        <component ref="c_model_input"
                   :innerTabs="innerTabs"
                   :chip="chip.toString()"
                   :selectRule="selectRule"
                   :current.sync="curInnerTab"
                   :is="componentName"
                   :data="tabItemData"
                   @lm_change="lm_change"
                   class="component"/>

        <c-input class="c-input" v-model="chip" @again="handle_again" @certain="certain_handle"
                 @reset="reset_selected"/>

        <v-statistic @showRule="onShowRule" class="page-side"/>
      </div>
    </template>
    <template>
      <div class="listen">
        <audio controls="controls" hidden id="audio1">
          <source src="../../../assets/1.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio2">
          <source src="../../../assets/2.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio3">
          <source src="../../../assets/3.mp3" type="audio/mpeg"/>
        </audio>
      </div>
    </template>
    <order ref="order" @submit="order_sub" :orders="orders"/>
  </div>
</template>

<script>
  import methods from '../methods';
  import Order from '../../../components/dialog/order';
  import VStatistic from '../../../components/c_statistics';
  import LMP from '../../../components/pageComponents/gd_ha10/lmp'
  import DH18 from '../../../components/pageComponents/gd_ha10/dh18';
  import VBall from '../../../components/pageComponents/gd_ha10/ball'
  import ZMZH from '../../../components/pageComponents/gd_ha10/zmzh'
  import LM from '../../../components/pageComponents/gd_ha10/lm'
  import VPTop from '../../../components/c_top';
  import VTab from '../../../components/c_tab';
  import CInput from '../../../components/c_a-input';
  import eventMixin from '../../../utils/eventMixin';
  import {computedData} from '../../../utils/computed';
  import {mapState, mapActions} from 'vuex';
  import Vue from "../../../utils/bus";
  const each = (cb, el) => {
    (el.name === 'g_input_selected_item' || el.name === 'g_input_selected_item_type_2') && cb(el);
    if (el.$children.length > 0) el.$children.forEach(child => each(cb, child));
  };

  export default {
    name: "cc_ssc",
    mixins: [eventMixin, methods],
    components: {
      Order,
      LMP,
      VBall,
      DH18,
      ZMZH,
      LM,
      VPTop,
      VTab,
      CInput,
      VStatistic
    },
    data() {
      return {
        origin_list: null,
        // 最后选择的订单号
        orders: [],
        order_subing: false,
        // 连码选择
        curInnerTab: 0,
        // 筹码
        chip: '',

        time: 0,
        contentStyleObj: {
          height: ''
        },
      }
    },
    watch: {
      curInnerTab() {
        this.reset_selected();
      }
    },
    computed: {
      innerTab() {
        return this.innerTabs.find(item => item.value === this.curInnerTab) || {};
      },
      // 连码选择
      innerTabs() {
        return this.odds.map(item => ({
          ...item,
          id: item.lottery_type,
          label: item.played_name+""+item.odds,
          value: item.id
        }));
      },

      // 封盘倒计时
      remain_time() {
        return this.lottery.next_info.remain_time;
      },

      block_time() {
        return this.lottery.next_info.block_time;
      },
      next_phase() {
        return this.lottery.next_info.period;
      },
      // 期数
      phase() {
        return this.lottery.latest_result.period;
      },
      // 开奖号码
      records() {
        return this.lottery.latest_result.number ? this.lottery.latest_result.number.split(',') : [];
      },
      ...mapState({
        order_history: state => state.home_gd_ha10.order_history,
        curTab: state => state.home_gd_ha10.curTab,
        headTabs: state => state.home.headTabs,
        tabs: state => state.home_gd_ha10.tabs,
        odds: state => state.home_gd_ha10.odds,
        lottery: state => state.home_gd_ha10.lottery,
        longQueue: state => state.home.longQueue,
        statistics: state => state.home.statistics
      }),
      current() {
        return this.tabs[this.curTab] || null;
      },
      head() {
        return this.headTabs.find(item => item.lottery_type == (this.$route.query.lottery_type || 1)) || {};
      },
      componentName() {
        const _cur = this.current;

        if (!_cur) return '';

        let _name = 'l-m-p';
        switch (_cur.sub_category_id) {
          // 两面盘
          case 1:
            _name = 'l-m-p';
            break;
          case 2:
            _name = 'd-h18';
            break;
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
            _name = 'v-ball';
            break;
          case 11:
            _name = 'z-m-z-h';
            break;
          case 12:
            _name = 'l-m';
            break;
        }
        return _name;
      },
      tabItemData() {
        const odds = this.odds.map(item => {
          if (!item._status) item._status = item.status;
          if (!this.time) {
            item.status = 3;
          } else if (item.status === 3) {
            item.status = item._status;
          }
          return item;
        });

        return computedData(odds, this.current, this.curInnerTab);
      }
    },
    methods: {
      ...mapActions({
        createOrder: 'home_gd_ha10/createOrder',
        getNewLotteryRes: 'home_gd_ha10/getNewLotteryRes',
        updateUserInfo: 'root/updateUserInfo',
        getLotteryLatest: 'home/getLotteryLatest',
        getLongQueue: 'home/getLongQueue',
        getStatistics: 'home/getStatistics'
      }),
      // 允许选中条件
      selectRule(type, selected) {
        if (type === 5 && selected) {
          let total = 0;
          each(item => {
            if (item.selected) total++;
          }, this.$refs.c_model_input);
          return total < 8;
        }
        return true;
      },

      // 连码触发
      lm_change(value) {
        this.curInnerTab = value;
      },
      getHeight() {
        this.contentStyleObj.height = window.innerHeight - 220 + 'px';
      },
    },
    created() {
      var lett = this;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13) {
          if (lett.$refs.order.showOrderDialog === true) {
            lett.$refs.order.handle_submit();
          } else {
            lett.certain_handle();
          }
        }
      }

      window.addEventListener('resize', this.getHeight);
      this.getHeight()
    }

  }
</script>

<style scoped lang="stylus">
  .gd_hao10 {
    font-size 13px

    .gd_hao10-main {
      background-color #ffffff
    }
  }

  .input-bottom {
    position absolute
    bottom 0
    width 100%
    left 10px
    margin-top 20px
  }

  .num_record {
    margin-top 10px

    > .item2 {
      margin 0 10px
      width 27px
      height 27px
    }

    > .itemnc {
      margin 0 12px
      width 27px
      height 27px
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/gd_ha10/index.vue